<template>
  <BaseWarning>
    <i18n :path="path" tag="span">
      <template #scoreName>
        <a
          href="https://www.guidetofm.com/tactics/choosing-roles-duties/#general-considerations"
          target="_blank">
          {{ score }}
        </a>
      </template>
      <template #calculatedScore>{{ data.calculatedScore }}</template>
      <template #effect>
        <a :href="effectURLs[data.scoreName]" target="_blank">{{ effect }}</a>
      </template>
      <template #targetScore>{{ data.targetScore }}</template>
    </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from "./BaseWarning.vue";

export default {
  name: "WarningForwardMovement",
  
  props: {
    data: Object
  },

  components: { BaseWarning },

  data: function() {
    return {
      effectURLs: {
        penetration: "https://www.guidetofootball.com/tactics/attacking-objectives/#penetrating-space",
        solidity: "https://www.guidetofootball.com/tactics/attacking-objectives/#retaining-solidity",
        support: "https://www.guidetofootball.com/tactics/attacking-objectives/#providing-attacking-support"
      }
    }
  },

  computed: {
    path: function () {
      return (
        "warnings.forwardMovement.warning" +
        (this.data.side == null
          ? ""
          : this.data.side.charAt(0).toUpperCase() +
            this.data.side.slice(1).toLowerCase())
      );
    },

    score: function () {
      return this.$t(`stats.forwardMovement.${this.data.scoreName}Score`);
    },

    effect: function () {
      return this.$t(`warnings.forwardMovement.${this.data.scoreName}ScoreEffect`);
    },
  },
};
</script>
